var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPaltelTroubleTicket(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9838_5206",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 29,
    height: 29
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.4109 0.712891H0.410889V28.7129H28.4109V0.712891Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9838_5206)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.6152 4.64956C17.1031 2.97604 19.3024 1.93504 20.5328 2.19853C20.9031 2.27785 21.0213 2.69394 20.9228 3.05968L19.7126 7.55286C19.6141 7.9186 19.7307 8.3086 20.0137 8.56027L21.0583 9.489C21.3414 9.74068 21.7424 9.81082 22.0941 9.67018L26.4147 7.94247C26.7664 7.80183 27.1935 7.87055 27.3156 8.2291C27.7213 9.42014 26.9448 11.7262 25.4569 13.3997C23.6251 15.46 21.3277 16.3343 18.7317 15.8348C18.3598 15.7632 17.9703 15.8743 17.7186 16.1574L8.50418 26.5214C7.62916 27.5056 6.75415 28.4898 4.78581 26.7397C2.81746 24.9897 3.69248 24.0055 4.56749 23.0214L13.782 12.6574C14.0336 12.3743 14.0984 11.9745 13.9838 11.6135C13.184 9.09375 13.7834 6.70989 15.6152 4.64956Z",
    stroke: "#76BC21",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaltelTroubleTicket);
export default __webpack_public_path__ + "static/media/paltelTroubleTicket.7a992dc5a860743871b7fb9ff8ac28e3.svg";
export { ForwardRef as ReactComponent };